export const VIDEO_URL = "https://youtu.be/pgjBuLpZAvU";
export const BUY_URL = "https://orgasmicoffers.com/cc";

export const PRIVACY_URL = "https://api.anubesolutions.com/preview/EtXydsJ3vcZssOI97ehy";
export const TERMS_URL = "https://api.anubesolutions.com/preview/uA4QE3RBzv0cugNb5TmU";
export const CONTACT_EMAIL = "coaching@dasha.love";

export const METHOD_CHAIN = ["One crazy idea", "One unique blueprint", "Become the message", "Systemize it", "Transmit it everywhere"];

export const METHOD = [
  {
    n: "01", title: "Decide", tag: "Decide the crazy, belief-shifting idea you’re willing to stand for.",
    blocks: [
      ["p", "What’s the WTF belief your book, videos, offers—and ultimately your life’s work—are going to defend?"],
      ["p", "What does your dream client believe right now?"],
      ["p", "And what do you know that could make them stop and say:"],
      ["quote", "“Wait… WHAT?! What if that’s true?”"],
      ["p", "You’re not here to say everything you know."],
      ["lead", "You’re here to become known for ONE idea worth spreading."],
      ["flow", ["OLD BELIEF", "WTF IDEA", "NEW POSSIBILITY"]],
    ],
  },
  {
    n: "02", title: "Blueprint", tag: "Turn the WTF idea into your unique 3–7 step method for making it real.",
    blocks: [
      ["p", "If your new belief is true, what’s the actual path someone follows to experience it for themselves?"],
      ["p", "We pull from your lived experience, expertise, Human Design + Gene Keys to help uncover a method and message aligned with how you naturally lead."],
      ["p", "Then build the ascension path that takes someone deeper into the belief and transformation through increasing levels of proximity and support."],
      ["flow", ["ONE BELIEF", "ONE METHOD", "ONE TRANSFORMATION", "MULTIPLE LEVELS OF PROXIMITY"]],
      ["lead", "This becomes your intellectual property."],
    ],
  },
  {
    n: "03", title: "Embody", tag: "Become the message. Remember: YOU ARE IT.",
    blocks: [
      ["stack", ["Don’t just teach the belief.", "Become evidence of it."]],
      ["p", "Speak your book as an embodiment experience while using movement, breathwork, meditation, somatic work and other embodiment practices to uncover and shift the beliefs inside YOU."],
      ["stack", ["Your stories become the proof.", "Your realizations become the message.", "Your transformation becomes part of the method."]],
      ["p", "And your book becomes two journeys happening at once:"],
      ["flow", ["THEIR BELIEF-SHIFTING JOURNEY", "YOUR EMBODIMENT JOURNEY"], "and"],
      ["p", "You don’t just write the message."],
      ["lead", "You become it."],
    ],
  },
  {
    n: "04", title: "Systemize", tag: "Build the machine that delivers, sells and scales the message.",
    blocks: [
      ["p", "Your book, videos and content begin the sales conversation before you ever get on the call."],
      ["stack", ["They shift limiting beliefs.", "They tell the stories.", "They demonstrate your method.", "They help your person understand:"]],
      ["flow", ["WHERE I AM", "WHO I BECOME", "WHAT BECOMES POSSIBLE"]],
      ["p", "Then your high-value transformational offer becomes the natural next step for the person who wants your help actually living the transformation."],
      ["p", "Build the funnels, AI, follow-up, appointment booking and sales systems that allow your ONE message to keep creating conversations and opportunities without you manually doing everything."],
      ["flow", ["MESSAGE", "CONTENT", "CONVERSATION", "OFFER", "SALE"]],
    ],
  },
  {
    n: "05", title: "Transmit", tag: "Make your entire world point back to the idea—and trust the process.",
    blocks: [
      ["stack", ["Your book transmits it.", "Your videos transmit it.", "Your content transmits it.", "Your offers transmit it.", "Your environment transmits it.", "Your language transmits it.", "Your brand transmits it.", "Your life transmits it."]],
      ["p", "Stop reinventing your message every week."],
      ["p", "Say the same revolutionary idea a thousand different ways."],
      ["p", "Let everything you create reinforce the world you believe is possible."],
      ["lead", "Become known for the idea."],
      ["lead", "Trust yourself. Trust the message. Trust the process. Keep transmitting."],
    ],
  },
];

export const SYSTEM_SUMMARY = [["Decide", "the belief."], ["Blueprint", "the transformation."], ["Embody", "the message."], ["Systemize", "the sales."], ["Transmit", "the idea."]];

export const AI_BULLETS = [
  "nurture the lead",
  "educate them about your philosophy",
  "share your stories, videos and content",
  "answer common questions",
  "explain your offers",
  "qualify potential clients",
  "invite qualified people to book",
  "continue following up until they make a decision",
];

export const TESTIMONIALS = [
  { q: "Happy Tuesday!! I’m still in shock. We channeled my 18-chapter book in just 45 minutes and I sold out my high ticket offer in 3 weeks!", img: "tm-healing" },
  { q: "What a unique experience — having a book published without writing a single word myself! It uses my authentic voice and my story.", img: "tm-dog" },
  { q: "I had an idea for a book, and before I knew it, you got it published! Absolute wizardry.", img: "tm-monogamy" },
  { q: "We finished my book in 2 weeks, set up a landing page with my high-ticket offer, and had a CRM system completely set up to collect & nurture leads automatically!!! This is the most impressive system I’ve ever seen. You are a genius, Dasha!", img: "tm-hero" },
  { q: "After years of self-doubt, I finally published my book — thanks to you! Your support and incredible insights.", img: "tm-voice" },
  { q: "Fastest process EVER!! With Human Design and Gene Keys we created a custom framework that’s helping me build momentum and SELL high-ticket offers.", img: "tm-fearless" },
  { q: "Just finished my book in 1 day @ ascension plan for high-ticket offer after a few sessions with Dasha. My landing page is set up and I am ready to sell my offer 1→many.", img: "tm-freedom" },
  { q: "She helped me remember that my blueprint – book – brand – business is a sacred temple of expansion for myself and my soul tribe and they are here to pay for proximity to embody new identity.", img: "tm-quantum" },
  { q: "My new business went to $300,000 in 6 months and then got the $2.5M property, 41 acres in my name. Benefit you taught me to be clear and how to sell.", by: "Alma Wellness" },
  { q: "It’s crazy Dash. The $100K investment came in from the guy on the vision board after the clear vision and embodiment work. 2 years later almost everything came true — Aubrey Marcus speaking on the stage. You got the fire to thunderfuck me into my highest timeline." },
  { q: "I went from broke + invisible to $50K months consistently. Your teachings changed everything.", by: "Daniella" },
  { q: "This is crazy. $2M in 6 months in production company. Your human design and alignment frequency is priceless.", by: "Sama" },
  { q: "Went from $897 → 5K for my group coaching. Started selling just 2 weeks after working with Dasha. 6-figure vision dialed in. Masterclass ready. Blueprint → book done. And it’s only been one month." },
  { q: "I landed my DREAM client. $25K deal because of your sales framework. Game changer!", by: "Mel" },
  { q: "The identity shift because of the book unlocked my content alpha state and clients started pouring in. $103K so far.", by: "unfuck yo self" },
  { q: "Just got rid of all my debt and I’m up and running in my own construction business — in just 3 weeks. And I’m only 22. Followed Dasha’s Human Design. It works." },
  { q: "After our call I raised my prices 3X and signed 2 new clients the same week! I’m in a whole new reality now.", by: "Leila" },
  { q: "Within 3 months my whole new business, high-ticket offer with an ascension plan and all systems is dialed in. Dasha and Jessica changed my life, I am becoming a million dollar mompreneur in the dental space." },
  { q: "One session unlocked the keys my company wasn’t able to do in 1.5 years.", by: "Sumar" },
  { q: "I used to play small and people pleased. Now I lead, I sell, I impact… and I get paid BIG. Thank you for seeing me!", by: "Tasha" },
  { q: "Thank you for the speaker voice activation. Stages are so fun now.", by: "Rachel" },
];
